import { Component, OnInit, Inject, OnDestroy, Input, ChangeDetectionStrategy } from '@angular/core';
import { RechargeBoxService } from '../../../_service/recharge-box/recharge-box.service';
import { AppStore } from '../../../app.store';
import { Store } from 'redux';
import { ConfigState } from 'app/_model/config/config.reducer';
import { environment } from '../../../../environments/environment';
import { ApiUrlHelper } from 'app/_service/api-url-helper';
import { HttpClientHelper } from 'app/_service/http-helper';
import { StorageService } from 'app/storageprovider';
@Component({
  selector: 'app-dn-footer-menu',
  templateUrl: './dn-footer-menu.component.html',
  styleUrls: ['./dn-footer-menu.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush

})

export class DnFooterMenuComponent implements OnInit, OnDestroy {
 // allVip = false;
  @Input() menuType;
  // subscript = null;
  @Input() partnerList = [];
  // lastRegion = '';
  constructor(
    private _rechargeBoxService: RechargeBoxService
  ) {

  }

  ngOnInit() {
    // if (this.menuType === 'partner') {
    //   const region = this._storage.GetConfig()['region'];
    //   // console.log(region);
    //   this.getPartnerList(region);
    //   this.subscript = this.store.subscribe(() => {
    //     const region = this._storage.GetConfig()['region'];
    //     if (this.lastRegion !== region) {
    //       this.getPartnerList(region);
    //     }
    //   });
    // }
  }

  showRechargeBox() {
    this._rechargeBoxService.changeDisplayStatus(true);
    // this._router.navigate(['/vip-center/recharge'], { queryParams: {forOther: '0'} });
  }
  cinema = environment.cinema;

  ngOnDestroy(): void {
    // if (this.menuType === 'partner') {
    //   this.subscript();
    // }
  }

  // getPartnerList(region) {
  //   this.lastRegion = region;
  //   this.getCoBusiness(region).subscribe((r: any) => {
  //     // console.log(r);
  //     if (r.list) {
  //       this.partnerList = r.list;
  //     } else {
  //       this.partnerList = [];
  //     }
  //   });
  // }

  // getCoBusiness(region): Observable<any[]> {
  //   const apiURL = this._apiUrlHelper.urlBuilder(
  //     'get-co-business',
  //     {
  //       region: region,
  //       page: 1,
  //       size: 8,
  //     }
  //   );
  //   return this._httpClientHelper.get(apiURL).pipe(map(res => {
  //     return res[0];
  //   }));
  // }
}

